import { createSelector } from 'reselect'

const searchLessonsViewSelector = createSelector(
	[state => state.libraries, state => state.lessons],
	(libraries, lessonsList) => {
		let lessonsIds
		if (libraries.find_lessons.show_selected && !libraries.find_lessons.selected_all) {
			lessonsIds = libraries.find_lessons.selected_lessons
		} else {
			lessonsIds = libraries.find_lessons.lessons
		}
		const lessons = lessonsIds.map(function(id) {
			return lessonsList[id]
		})

		const areFiltersApplied = libraries.find_lessons.search.query.applied_filters.length !== 0 || libraries.find_lessons.search.query.applied_keyword !== ''
		const show_empty_results = libraries.find_lessons.status !== 0 && lessons.length === 0 && !libraries.find_lessons.show_selected
		const show_results_box = (libraries.find_lessons.status !== 0 && lessons.length !== 0 && areFiltersApplied) || libraries.find_lessons.show_selected
		const show_loading = libraries.find_lessons.loading && libraries.find_lessons.search.page === 0 && areFiltersApplied

		return {
			filter_definitions: libraries.filter_definitions,
			selected_filters: libraries.find_lessons.search.component.selected_filters,
			applied_filters: libraries.find_lessons.search.query.applied_filters,
			applied_keyword: libraries.find_lessons.search.query.applied_keyword,
			input_value: libraries.find_lessons.search.component.input_keyword,
			order_type: libraries.find_lessons.search.query.order_type,
			order_field: libraries.find_lessons.search.query.order_field,
			filters_modal_open: libraries.find_lessons.search.component.open,
			more: libraries.find_lessons.search.more && !libraries.find_lessons.show_selected,
			active: libraries.find_lessons.active,
			selected_lessons: libraries.find_lessons.selected_lessons,
			show_selected: libraries.find_lessons.show_selected,
			selected_all: libraries.find_lessons.selected_all,
			total_entities_found: libraries.find_lessons.total_entities_found,
			status: libraries.find_lessons.status,
			show_empty_results,
			show_results_box,
			show_loading,
			library_type: libraries.current.settings.entity_type,
			libraryUID: libraries.current.libraryUID,
			lessons,
		}
	}
)

export default searchLessonsViewSelector
